import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types, Creators } = createActions({
	// Actions Saga
	dacaBuscarPorId: ['dacaId', 'callback'],
	dacaSalvar: ['daca', 'callback'],
	dacaFiltro: ['filtro', 'callback'],
	dacaReset: [],

	// Actions reducers
	dacaBuscarPorIdReducer: ['daca'],
	dacaSalvarReducer: ['daca'],
	dacaFiltroReducer: ['lista'],
	dacaResetReducer: [],
});

export const INITIAL_STATE_VALUES = {
	daca: {
		id: 0,
		nome: '',
		descricao: '',
		tiposExibicao: [],
		permanente: '',
		patrimoniado: '',
	},
	lista: {
		content: [],
		pageable: {
			sort: {
				unsorted: true,
				sorted: false,
			},
			pageSize: 20,
			pageNumber: 0,
			offset: 0,
			unpaged: false,
			paged: true,
		},
		last: true,
		totalPages: 1,
		totalElements: 1,
		numberOfElements: 1,
		first: true,
		sort: {
			unsorted: true,
			sorted: false,
		},
		size: 20,
		number: 0,
	},
};

const INITIAL_STATE = Immutable(Object.assign({}, INITIAL_STATE_VALUES));

const dacaBuscarPorId = (state = INITIAL_STATE, action) => state.merge({
	daca: { ...action.daca },
});

const dacaSalvar = (state = INITIAL_STATE, action) => state.merge({ daca: { ...action.daca } });

const dacaFiltroReducer = (state = INITIAL_STATE, action) => state.merge({
	lista: { ...action.lista },
});

const dacaResetReducer = (state = INITIAL_STATE) => state.merge({
	daca: { ...INITIAL_STATE_VALUES.daca },
});

export default createReducer(INITIAL_STATE, {
	[Types.DACA_BUSCAR_POR_ID_REDUCER]: dacaBuscarPorId,
	[Types.DACA_SALVAR_REDUCER]: dacaSalvar,
	[Types.DACA_FILTRO_REDUCER]: dacaFiltroReducer,
	[Types.DACA_RESET_REDUCER]: dacaResetReducer,
});
